import gql from 'graphql-tag';

export const GET_SURVEY_QUESTIONS = gql`
  query GetSurveyQuestions(
    $surveyType: String
  ) {
    surveyQuestions(
      surveyType: $surveyType
    ) {
      surveyQuestions {
        id
        isRequired
        position
        questionText
        questionType
        surveyQuestionOptions {
          id
          optionText
          position
        }
        surveyType
      }
    }
  }
`;
